import m from "../../geodata/es2015/northKoreaHigh";
window.am4geodata_northKoreaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/northKoreaHigh.js
// module id = null
// module chunks = 